import { render, staticRenderFns } from "./RelationGroupsOverview.vue?vue&type=template&id=590f706e"
import script from "./RelationGroupsOverview.vue?vue&type=script&lang=js"
export * from "./RelationGroupsOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports